<div class="row-no-margin" [hidden]="!CurrentScreenOption.IsVisible" >
  <label [htmlFor]="CurrentScreenOption.ID" [ngClass]="{'invalid' : !CurrentScreenOption.IsValid}">{{CurrentScreenOption.Caption + " " + CurrentScreenOption.Description}}</label>
  <div class="row-no-margin">
    <div *ngFor="let opt of CurrentScreenOption.SelectableValues" class="CPQComponent">
      <input [checked]="opt.Value == CurrentScreenOption.Value"
             type="radio"
             id="{{CurrentScreenOption.ID}}"
             name="{{CurrentScreenOption.ID}}"
             value="{{opt.Value}}"
             [disabled]="!CurrentScreenOption.IsEnabled"
             required="{{CurrentScreenOption.IsRequired}}"
             (change)="onChangeEmitter(opt.Value)" />
      <label for="{{CurrentScreenOption.ID}}">{{opt.Caption}}</label>
    </div>
  </div>
</div>
